import styled from "styled-components";
import { color, units } from "@m/alchemy-theme";
import { CardHeader } from "./CardHeader.styled";
export const CardBody = styled.div `
  color: ${color("typeBody")};
  padding: ${units(3)};
  width: 100%;
  flex-grow: 1;

  ${CardHeader} + & {
    padding-top: 0;
  }
`;
